import { useFlashToast } from "~/hooks/use_flash_toast";

export function FlashToaster(): null {
  useFlashToast();

  return null;
}
